module.exports = __webpack_public_path__ + "img/event_note_outlined.16ac5db9.svg";